import { __, sprintf } from '@wordpress/i18n';

// A project shows the "due" label as soon as it is 2 weeks or less from its
// deadline. That label wins over "new", so a freshly created project that is
// already due soon shows the deadline, never the "new" tag.
const DUE_SOON_DAYS = 14;
const NEW_FOR_DAYS = 7;

const startOfDay = (value) => {
    if (!value) return null;
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return null;
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};

const daysBetween = (from, to) => Math.round((to - from) / 86400000);

const getDueText = (daysLeft) => {
    if (daysLeft < 0) return __('overdue', 'soundbetween');
    if (0 === daysLeft) return __('due today', 'soundbetween');
    if (1 === daysLeft) return __('due in 1 day', 'soundbetween');
    if (0 === daysLeft % 7) {
        const weeks = daysLeft / 7;
        return 1 === weeks
            ? __('due in 1 week', 'soundbetween')
            : sprintf(__('due in %d weeks', 'soundbetween'), weeks);
    }
    return sprintf(__('due in %d days', 'soundbetween'), daysLeft);
};

/**
 * Resolve the single label shown on top of a project card thumbnail.
 * @param {Object} project - project as returned by /projects/list
 * @param {Date} [now] - reference date, injectable for tests
 * @returns {{type: 'due'|'new', text: string}|null}
 */
const getProjectCardLabel = (project, now = new Date()) => {
    if (!project) return null;

    const today = startOfDay(now);
    const deadline = startOfDay(project.deadline);

    if (deadline) {
        const daysLeft = daysBetween(today, deadline);

        if (daysLeft <= DUE_SOON_DAYS) {
            return { type: 'due', text: getDueText(daysLeft) };
        }
    }

    const created = startOfDay(project.creationDate);

    if (created && daysBetween(created, today) < NEW_FOR_DAYS) {
        return { type: 'new', text: __('new', 'soundbetween') };
    }

    return null;
};

export default getProjectCardLabel;
